import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Menu, MenuItem, Button } from '@mui/material';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";

import { MentionExtension } from "@tiptap/extension-mention";
import AddMiniProjectEditor from './AddMiniProjectEditor';




const users = [
    { id: "1", name: "John Doe" },
    { id: "2", name: "Jane Smith" },
    { id: "3", name: "Alice Brown" },
];

const TaskRemakrsModal = ({ show, handleClose }) => {

    //===============================Select Project Head===========================
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handlePMClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePMClose = () => {
        setAnchorEl(null);
    };
    //===============================Date Range picker===========================
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    //===============================Currency Symbol=================
    const [currency, setCurrency] = useState({
        symbol: "$",
        placeholder: "0.00",
    });

    const handleCurrencyChange = (event) => {
        const selectedOption = event.target.selectedOptions[0]; // Get selected option
        setCurrency({
            symbol: selectedOption.dataset.symbol,
            placeholder: selectedOption.dataset.placeholder
        });
    };

    //dark theme select
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    // Check for the theme by looking at the body's class list
    useEffect(() => {
        const checkTheme = () => {
            setIsDarkTheme(document.body.classList.contains("dark-theme"));
        };

        // Initial check
        checkTheme();

        // MutationObserver to detect theme changes on body
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Clean up observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme select end



    return (
        <>
            <Modal id="TaskRemarksModal" show={show} onHide={handleClose} backdrop="static" centered size="md">
                <Modal.Header closeButton className='gth-blue-light-bg'>
                    <Modal.Title className="gth-modal-title">UI Design for Login Page</Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <div className='row'>                        
                        <div className='col-lg-12'>
                            <div className='form-group'>
                                <label className='form-label'>Remarks </label>
                                <textarea className='form-control' rows={3} placeholder='Type your remarks here'></textarea>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="gth-blue-light-bg">
                    <button type='button' className="btn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type='button' className="btn btn-exp-green" onClick={handleClose}>
                        Update
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TaskRemakrsModal;
